import React from 'react/addons';
import Radium from 'radium';
import {gettext} from 'ofs/i18n';
import {colors, typography, magicNumbers} from 'ofs/apps/homes/detail/views/styles';

const baseTypeUnit = 0.5;
const baseLineHeight = 3 * baseTypeUnit;
const verticalSpacing = baseLineHeight;
const smallVerticalSpacing = baseLineHeight / 2;
const smallHorizontalSpacing = smallVerticalSpacing * magicNumbers.constants.phi;

const styles = {
  table: {
    background: '#fff',
    margin: '0px auto',
    width: '100%',
    "@media (max-width: 769px)": {
      fontSize: '0.9em',
      height: '100%',
      position: 'absolute',
      left: '0',
      top: '0',
    },
  },
  td: {
    padding: `${smallVerticalSpacing}rem ${smallHorizontalSpacing}rem`,
    borderLeft: `1px solid ${colors.vLightGreyColour}`,
  },
  tr: {
    borderTop: `1px solid ${colors.vLightGreyColour}`,
  },
  titleRow: {
    borderTop: '0'
  },
  iconColumn: {
    borderLeft: '0',
    fontSize: '2.3125rem',
  },
  middle: {
    backgroundColor: colors.vLightGreyColour,
    textAlign: 'center',
  }
};

var messages = {
  US_HOMES: gettext("In US homes"),
  EUROPEAN_HOMES: gettext("In European<br />homes"),
  BED_WIDTH: gettext("Bed width"),
  APPROX_SIZE: gettext("Approx size"),
  SMALL_SINGLE: gettext("Small single/child"),
  SMALLER_THAN: gettext("Smaller than"),
  SINGLE: gettext("Single"),
  SMALL_DOUBLE: gettext("Small double"),
  DOUBLE: gettext("Double"),
  QUEEN: gettext("Queen"),
  KING: gettext("King"),
  SUPER_KING: gettext("Super king")
};

@Radium
export default class BedSizeChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="bed-size-chart">
        <table style={styles.table}>
          <tbody>
            <tr style={styles.titleRow}>
               <td style={[styles.td, styles.iconColumn]}>&nbsp;</td>
               <td style={styles.td}>{messages.US_HOMES}</td>
               <td style={styles.td} dangerouslySetInnerHTML={{__html: messages.EUROPEAN_HOMES}}></td>
               <td style={styles.td}>{messages.BED_WIDTH}</td>
            </tr>
            <tr style={styles.tr}>
               <td style={[styles.td, styles.iconColumn]}><span className="icon-bed-size-small-single-notext"></span></td>
               <td ref="middle" style={[styles.td, styles.middle]} colSpan="2">{messages.SMALL_SINGLE}</td>
               <td style={styles.td}>{messages.SMALLER_THAN} 80cm<br /><br />31in</td>
            </tr>
            <tr style={styles.tr}>
               <td style={[styles.td, styles.iconColumn]}><span className="icon-bed-size-single-notext"></span></td>
               <td ref="middle2" style={styles.middle} colSpan="2">{messages.SINGLE}</td>
               <td style={styles.td}>80 &ndash; 110cm<br /><br />31 &ndash; 43in</td>
            </tr>
            <tr style={styles.tr}>
               <td style={[styles.td, styles.iconColumn]}><span className="icon-bed-size-small-double-notext"></span></td>
               <td ref="middle3" style={styles.middle} colSpan="2">{messages.SMALL_DOUBLE}</td>
               <td style={styles.td}>110 &ndash; 125cm<br /><br />43 &ndash; 49in</td>
            </tr>
            <tr style={styles.tr}>
               <td style={[styles.td, styles.iconColumn]}><span className="icon-bed-size-double-notext"></span></td>
               <td ref="middle4" style={styles.middle} colSpan="2">{messages.DOUBLE}</td>
               <td style={styles.td}>125 &ndash; 150cm<br /><br />49 &ndash; 59in</td>
            </tr>
            <tr style={styles.tr}>
               <td style={[styles.td, styles.iconColumn]}><span className="icon-bed-size-queen-notext"></span></td>
               <td style={styles.td}>{messages.QUEEN}</td>
               <td style={styles.td}>{messages.KING}</td>
               <td style={styles.td}>150 &ndash; 170cm<br /><br />59 &ndash; 67in</td>
            </tr>
            <tr style={styles.tr}>
               <td style={[styles.td, styles.iconColumn]}><span className="icon-bed-size-king-super-notext"></span></td>
               <td style={styles.td}>{messages.KING}</td>
               <td style={styles.td}>{messages.SUPER_KING}</td>
               <td style={styles.td}>170 &ndash; 190cm<br /><br />67 &ndash; 75in</td>
            </tr>
           </tbody>
        </table>
      </div>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/utils/BedSizeChart.jsx
 **/